export const bucketsMock = [
  {
    id: "1",
    bucketName: "arkiv",
    bucketSize: 15923.2,
    objects: 31867785,
    location: "no-east",
  },
  {
    id: "2",
    bucketName: "beregninger",
    bucketSize: 12715,
    objects: 442,
    location: "no-west",
  },
  {
    id: "3",
    bucketName: "eh-backup",
    bucketSize: 6400,
    objects: 233732,
    location: "no-west",
  },
  {
    id: "4",
    bucketName: "mtjenester",
    bucketSize: 2850,
    objects: 13400095,
    location: "no-west",
  },
  {
    id: "5",
    bucketName: "nasuni",
    bucketSize: 34700,
    objects: 985444,
    location: "no-west",
  },
];
